import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../badge/nn-badge.js';

/**
 * Nordnet Horizontal Generic Block atom. Used standalone.
 *
 * offer - The offer. (optional, i.e. SAT_TV)
 * thicker - Thicker first column. (boolean, default : false)
 * withoutImage : Show image. (boolean, defaut : false)
 * imageUrl : Url of the image. (string)
 * imageAlt : Alt of the image. (string)
 * imageWidth : Width of the image. (string)
 * imageHeight : Height of the image. (string)
 * withoutTitle : show title (boolean, default : false)
 * withoutText : show text (boolean, default : false)
 * contentTitle : Title in the block. (string)
 * contentText : Text in the block. (string)
 * biggerText : Set bigger text on contentText. (boolean, defaut : false)
 * withoutLink : show link (boolean, default : false)
 * linkUrl : url link (string)
 * linkText : link text (string)
 * badgeText : badge text (string)
 * withPrice : price text (string)
 */
@customElement('nn-horizontal-generic-block')
export class horizontalGenericBlock extends LitElement {
  static styles = css`
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .img-responsive {
      display: inline-block;
      height: auto;
      max-width: 100%;
    }
    .heading-04 {
      color: var(--nn-horizontal-generic-block_heading-04_color, #000);
      font-family: 'font-heavy';
      font-size: var(--nn-horizontal-generic-block_heading-04_font-size, 24px);
      line-height: var(
        --nn-horizontal-generic-block_heading-04_line-height,
        calc(2ex + 4px)
      );
      margin: var(--nn-horizontal-generic-block_heading-04_margin, 0);
      padding: var(--nn-horizontal-generic-block_heading-04_padding, 0);
    }
    .paragraph-02 {
      color: var(--nn-horizontal-generic-block_paragragh-02_color, #000);
      font-family: 'font-light';
      font-size: var(
        --nn-horizontal-generic-block_paragragh-02_font-size,
        16px
      );
      line-height: calc(2ex + 4px);
      margin: var(--nn-horizontal-generic-block_paragragh-02_margin, 0);
      padding: var(--nn-horizontal-generic-block_paragragh-02_padding, 0);
    }
    .paragraph-03 {
      color: var(--nn-horizontal-generic-block_paragragh-03_color, #000);
      font-family: 'font-light';
      font-size: var(
        --nn-horizontal-generic-block_paragragh-03_font-size,
        14px
      );
      line-height: calc(2ex + 4px);
      margin: var(--nn-horizontal-generic-block_paragragh-03_margin, 0);
      padding: var(--nn-horizontal-generic-block_paragragh-03_padding, 0);
    }
    .paragraph-03 p {
      color: var(--nn-horizontal-generic-block_paragragh-03_p_color, #000);
      font-size: var(
        --nn-horizontal-generic-block_paragragh-03_p_font-size,
        14px
      );
      margin: var(--nn-horizontal-generic-block_paragragh-03_p_margin, 0);
      padding: var(--nn-horizontal-generic-block_paragragh-03_p_padding, 0);
    }
    .subtitle-02 {
      color: var(--nn-horizontal-generic-block_subtitle-02_color, #000);
      font-family: 'font-heavy';
      font-size: var(--nn-horizontal-generic-block_subtitle-02_font-size, 20px);
      line-height: calc(2ex + 4px);
      margin: var(--nn-horizontal-generic-block_subtitle-02_margin, 0);
      padding: var(--nn-horizontal-generic-block_subtitle-02_padding, 0);
    }
    .anchor,
    .anchor:active,
    .anchor:focus,
    .anchor:visited,
    .anchor:hover {
      background: none;
      border: 0;
      box-shadow: none;
      color: var(--nn-horizontal-generic-block_anchor_color, #3695ec);
      display: inline-block;
      margin: var(--nn-horizontal-generic-block_anchor_margin, 0);
      padding: var(--nn-horizontal-generic-block_anchor_padding, 0);
      text-decoration: none;
      transition: all 0.3s;
      position: relative;
    }
    .anchor:hover {
      text-decoration: underline;
    }
    .anchor.with-picto:after {
      border-left: 2px solid
        var(
          --nn-horizontal-generic-block_anchor-with-picto--after_border-left-color,
          #3695ec
        );
      border-bottom: 2px solid
        var(
          --nn-horizontal-generic-block_anchor-with-picto--after_border-bottom-color,
          #3695ec
        );
      content: '';
      display: inline-block;
      height: var(
        --nn-horizontal-generic-block_anchor-with-picto--after_height,
        6px
      );
      transform: rotate(225deg);
      vertical-align: middle;
      width: var(
        --nn-horizontal-generic-block_anchor-with-picto--after_width,
        6px
      );
      position: absolute;
      right: var(
        --nn-horizontal-generic-block_anchor-with-picto--after_right,
        -13px
      );
      top: var(
        --nn-horizontal-generic-block_anchor-with-picto--after_top,
        calc(50% - 4px)
      );
    }
    .modal-generic-block .icon-inline--text .paragraph-03.anchor {
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_paragraph-03-anchor_color,
        #3695ec
      );
      display: inline-block;
      font-family: 'font-light';
      margin-top: var(
        --nn-horizontal-generic-block_modal-generic-block_paragraph-03-anchor_margin-top,
        4px
      );
    }
    .modal-generic-block {
      background: var(
        --nn-horizontal-generic-block_modal-generic-block_background,
        #fbfbfb
      );
      border: 1px solid
        var(
          --nn-horizontal-generic-block_modal-generic-block_border-color,
          #efefef
        );
      border-radius: var(
        --nn-horizontal-generic-block_modal-generic-block_border-radius,
        32px
      );
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_color,
        #494949
      );
      margin: var(
        --nn-horizontal-generic-block_modal-generic-block_margin,
        0 0 24px
      );
      padding: var(
        --nn-horizontal-generic-block_modal-generic-block_padding,
        0 40px
      );
    }
    .icon-inline {
      align-items: center;
      background: none;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      color: var(--nn-horizontal-generic-block_icon-inline_color, #000);
      display: flex;
      font-family: 'font-medium';
      font-size: var(--nn-horizontal-generic-block_icon-inline_font-size, 14px);
      justify-content: left;
      line-height: 1;
      margin: var(--nn-horizontal-generic-block_icon-inline_margin, 0);
      padding: var(--nn-horizontal-generic-block_icon-inline_padding, 0 0 5px);
      text-align: left;
      text-decoration: none;
      text-transform: none;
      vertical-align: inherit;
      width: 100%;
    }
    .icon-inline--text_title {
      font-family: 'font-heavy';
      padding: var(
        --nn-horizontal-generic-block_icon-inline--text_title_padding,
        0 0 3px
      );
    }
    .icon-inline--text_text {
      color: var(
        --nn-horizontal-generic-block_icon-inline--text_text_color,
        #666
      );
      font-size: var(
        --nn-horizontal-generic-block_icon-inline--text_text_font-size,
        0.929em
      );
    }
    .modal-generic-block .icon-inline.multiple {
      align-items: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--multiple_align_items,
        center
      );
      flex-wrap: wrap;
      min-height: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--multiple_min-height,
        130px
      );
    }
    .modal-generic-block .icon-inline--image {
      flex-basis: auto;
      flex-shrink: 0;
      margin: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--image_margin,
        0
      );
      text-align: center;
      width: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--image_width,
        160px
      );
    }
    .modal-generic-block .icon-inline--text {
      flex-basis: auto;
      flex-shrink: 0;
      padding: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_padding,
        0 0 0 24px
      );
      width: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_width,
        calc(100% - 160px)
      );
    }
    .modal-generic-block .icon-inline--text b,
    .modal-generic-block .icon-inline--text strong {
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_strong_color,
        #000
      );
      font-family: 'font-heavy';
      font-weight: normal;
    }
    .modal-generic-block .icon-inline--text_title {
      margin: 0;
    }
    .modal-generic-block .icon-inline--text .heading-04 {
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_heading-04_color,
        #323232
      );
      padding: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_heading-04_padding,
        0
      );
    }
    .modal-generic-block .icon-inline--text .paragraph-02,
    .modal-generic-block .icon-inline--text .paragraph-03 {
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_paragraph_color,
        #686868
      );
    }
    .modal-generic-block .icon-inline--text .paragraph-02.anchor,
    .modal-generic-block .icon-inline--text .paragraph-03.anchor {
      color: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_paragraph-anchor_color,
        #3695ec
      );
    }
    .modal-generic-block.without-image .icon-inline--text {
      padding: var(
        --nn-horizontal-generic-block_modal-generic-block-without-image_icon-inline--text_padding,
        0
      );
    }
    .icon-inline--text_text ul {
      list-style-type: none;
      margin: var(
        --nn-horizontal-generic-block_icon-inline--text_text_margin,
        0
      );
      padding: var(
        --nn-horizontal-generic-block_icon-inline--text_text_padding,
        0
      );
    }
    .icon-inline--text_text li {
      color: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li_color,
        #686868
      );
      list-style-type: none;
      padding: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li_padding,
        0 0 4px 12px
      );
      position: relative;
    }
    .icon-inline--text_text li:before {
      background: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_background,
        #686868
      );
      border-radius: 50%;
      content: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_content,
        ''
      );
      display: block;
      height: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_height,
        4px
      );
      margin: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_margin,
        0
      );
      padding: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_padding,
        0
      );
      width: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_width,
        4px
      );
      position: absolute;
      left: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_left,
        0
      );
      top: var(
        --nn-horizontal-generic-block_icon-inline--text_text_li--before_top,
        8px
      );
    }
    /* OPTIONS */
    .modal-generic-block.withoutImage .icon-inline--text {
      width: 100%;
    }
    .modal-generic-block.thicker .icon-inline--image {
      width: var(
        --nn-horizontal-generic-block_modal-generic-block-thicker_icon-inline--image_width,
        70px
      );
    }
    .modal-generic-block.thicker .icon-inline--text {
      width: var(
        --nn-horizontal-generic-block_modal-generic-block-thicker_icon-inline--text_width,
        calc(100% - 70px)
      );
    }
    .modal-generic-block.without-image .icon-inline--text {
      width: 100%;
    }
    .modal-generic-block.with-price .icon-inline--text {
      width: var(
        --nn-horizontal-generic-block_modal-generic-block-with-price_icon-inline--text_width,
        calc(100% - 320px)
      );
    }
    .modal-generic-block.with-price.thicker .icon-inline--text {
      width: var(
        --nn-horizontal-generic-block_modal-generic-block-thicker-with-price_icon-inline--text_width,
        calc(100% - 230px)
      );
    }
    .modal-generic-block.with-price.without-image .icon-inline--text {
      width: var(
        --nn-horizontal-generic-block_modal-generic-block-with-price-without-image_icon-inline--text_width,
        calc(100% - 160px)
      );
    }
    .modal-generic-block .icon-inline--price {
      flex-basis: auto;
      flex-shrink: 0;
      padding-left: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--price_padding,
        0 0 0 16px
      );
      text-align: right;
      width: var(
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--price_width,
        160px
      );
    }
    nn-badge + .icon-inline--text_title {
      padding-top: var(
        --nn-horizontal-generic-block_nn-badge_icon-inline--text_title_padding-top,
        4px
      );
    }
    nn-badge + .icon-inline--text_text {
      padding-top: var(
        --nn-horizontal-generic-block_nn-badge_icon-inline--text_text_padding-top,
        8px
      );
    }
    @media (max-width: 767px) {
      :host {
        --nn-horizontal-generic-block_heading-04_font-size: 21px;
        --nn-horizontal-generic-block_paragragh-02_font-size: 14px;
        --nn-horizontal-generic-block_paragragh-03_font-size: 12px;
        --nn-horizontal-generic-block_modal-generic-block_border-radius: 20px;
        --horizontal-generic-block_modal-generic-block_padding: 12px 16px;
      }
    }
    @media (max-width: 600px) {
      :host {
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_padding: 8px
          0 0;
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--text_width: 100%;
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--price_padding: 0
          0 8px;
        --nn-horizontal-generic-block_modal-generic-block_icon-inline--price_width: 100%;
        --nn-horizontal-generic-block_modal-generic-block-with-price_icon-inline--text_width: 100%;
      }
      .modal-generic-block .icon-inline {
        flex-direction: column;
      }
      .modal-generic-block .icon-inline--image,
      .modal-generic-block .icon-inline--text,
      .modal-generic-block .icon-inline--text .heading-04,
      .modal-generic-block .icon-inline--text .paragraph-03,
      .modal-generic-block .icon-inline--price {
        text-align: center;
      }
      .modal-generic-block .icon-inline--text_text {
        align-items: center;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
      }
      .icon-inline--text_text ul {
        margin: 0 auto;
        max-width: 100%;
        text-align: left;
        width: fit-content;
      }
      .modal-generic-block .icon-inline--price {
        order: 2;
      }
      .modal-generic-block.with-price .icon-inline--text {
        align-items: center;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        order: 3;
      }
      nn-badge {
        margin: 0 auto;
      }
    }
    @media (max-width: 479px) {
      :host {
        --nn-horizontal-generic-block_heading-04_font-size: 20px;
      }
    }
  `;

  @property({ type: String }) offer = '';

  @property({ type: Boolean }) thicker = false;

  @property({ type: Boolean }) withoutImage = false;

  @property({ type: Boolean }) biggerText = false;

  @property({ type: String }) imageUrl =
    'https://www.nordnet.com/build/images/produits/modal/television/channels.96ff75fc.webp';

  @property({ type: String }) imageAlt = '';

  @property({ type: String }) imageWidth = '142';

  @property({ type: String }) imageHeight = '132';

  @property({ type: String }) contentTitle = 'Le meilleur de la télévision';

  @property({ type: String }) contentText =
    'Le décodeur-enregistreur fourni comprend une carte FRANSAT HD pour capter les 27 chaînes de la TNT (TF1, France 2, France 3, etc.).';

  @property({ type: Boolean }) withoutLink = false;

  @property({ type: String }) linkUrl = '';

  @property({ type: String }) linkText = '';

  @property({ type: String }) badgeText = '';

  @property({ type: String }) withPrice = '';

  render() {
    return html`
      <div
        class="modal-generic-block${this.thicker ? ` thicker` : ``}${this
          .withoutImage
          ? ` without-image`
          : ``}${this.withPrice ? ` with-price` : ``} ${this.offer}"
      >
        <div class="icon-inline multiple">
          ${this.withoutImage
            ? ``
            : html`<div class="icon-inline--image">
                <img
                  class="img-responsive"
                  src="${this.imageUrl}"
                  alt="${this.imageAlt}"
                  aria-hidden="true"
                  width="${this.imageWidth}"
                  height="${this.imageHeight}"
                  loading="lazy"
                />
              </div>`}
          <div class="icon-inline--text">
            ${this.badgeText
              ? html`<nn-badge
                  text="${this.badgeText}"
                  variant="dark"
                ></nn-badge>`
              : ``}
            ${this.contentTitle
              ? html`<div class="icon-inline--text_title">
                  <div class="heading-04">
                    ${this.parseHtml(this.contentTitle)}
                  </div>
                </div>`
              : ``}
            <div class="icon-inline--text_text">
              ${this.contentText
                ? html`<div
                    class="${this.biggerText ? `paragraph-02` : `paragraph-03`}"
                  >
                    ${this.parseHtml(this.contentText)}
                  </div>`
                : ``}
              ${this.withoutLink
                ? ``
                : html`<a
                    class="${this.biggerText
                      ? `paragraph-02`
                      : `paragraph-03`} anchor with-picto"
                    href="${this.linkUrl}"
                    target="_blank"
                    rel="noopener"
                    >${this.parseHtml(this.linkText)}</a
                  >`}
            </div>
          </div>
          ${this.withPrice
            ? html`<div class="icon-inline--price subtitle-02">
                ${this.parseHtml(this.withPrice)}
              </div>`
            : ``}
        </div>
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  parseHtml(str?: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
}
